// extracted by mini-css-extract-plugin
module.exports = {"warning-red":"#d50000","label":"Label-module__label___i2Wnk","isRequired":"Label-module__isRequired___vaL4f"};